import React from "react";
import styles from "./index.module.css";
import Button from "shared/Button";
import Table from "shared/Table";

import { useRemoveGracePeriod } from "./useRemoveGracePeriod";

export function RemoveGracePeriod(props) {
  const { deleteGracePeriod } = useRemoveGracePeriod(
    props.record.id,
    props.onClose
  );

  return (
    <>
      <div style={{ width: "400px" }}>
        <Table>
          <thead>
            <th>graceAward</th>
            <th>newAward</th>
          </thead>
          <tbody>
            <tr>
              <td>{props.awards[props.record.graceAward].wwgDesc}</td>
              <td>{props.awards[props.record.newAward].wwgDesc}</td>
            </tr>
          </tbody>
          <tfoot />
        </Table>

        <div style={{ marginTop: "15px" }} />
        <Table>
          <thead>
            <th>periodStart</th>
            <th>periodEnd</th>
          </thead>
          <tbody>
            <tr>
              <td>{new Date(props.record.periodStart).toLocaleDateString()}</td>
              <td>{new Date(props.record.periodEnd).toLocaleDateString()}</td>
            </tr>
          </tbody>
          <tfoot />
        </Table>

        <div style={{ marginTop: "15px" }} />
        <Table>
          <thead>
            <th>Notes</th>
          </thead>
          <tbody>
            <tr>
              <td>{props.record.notes}</td>
            </tr>
          </tbody>
          <tfoot />
        </Table>
        <div style={{ paddingTop: "25px" }} />
        <div className={styles.buttonRow}>
          <Button className={styles.cancelButton} onClick={props.onClose}>
            Cancel
          </Button>
          <Button
            className={styles.deleteButton}
            onClick={(e) => {
              e.preventDefault();
              deleteGracePeriod(props.record.id);
            }}
          >
            Remove
          </Button>
        </div>
      </div>
    </>
  );
}
export default RemoveGracePeriod;
